import axios from 'axios'
import { api, lib } from '@giscube/geoportal'

const { getOrCall } = lib.toolUtils
const baseToolUtils = lib.toolUtils
const { notify } = lib.notifications

function _getHeadersAndParams (tool) {
  let params = tool.params || {}
  let headers = tool.headers || {}
  return { headers, params }
}

function executeUrlAction (tool) {
  if (tool.url) {
    window.open(tool.url, tool.target || '_blank')
  }
}

function executeWebhookAction (tool, self) {
  if (tool.url) {
    const { headers, params } = _getHeadersAndParams(tool)
    axios.get(tool.url, { params: params, headers: headers })
      .then(response => {
        notify('Funció executada correctament', { color: 'positive' })
      })
      .catch(error => {
        console.error('Error calling webhook:', error)
        self.$except(error)
      })
  }
}

function executeRouterToAction (tool, self) {
  if (tool.to) {
    self.$emit('sidebar-visibility-changed', true)
    self.$router.push({ name: tool.to })
  }
}

function executeJavascriptAction (tool, self) {
  if (tool.action) {
    tool.action.call(self, tool)
  }
}

const actions = {
  'url': executeUrlAction,
  'webhook': executeWebhookAction,
  'to': executeRouterToAction,
  'action': executeJavascriptAction
}

export function onToolClick (tool, self) {
  if (tool && self.$config.registers) {
    api.geoportal.newToolRegister(
      self.$config.registers,
      self.label,
      self.$store.getters['auth/config'],
      self.$store.state.auth.username
    )
  }

  if (tool.emit) {
    self.emit(getOrCall(tool.emit, self))
  }

  const actionFunction = actions[tool.action_type]
  if (typeof actionFunction === 'function') {
    actionFunction(tool, self)
  } else {
    console.warn(`[Mapia Streets] Action type "${tool.action_type}" is not supported.`)
  }
}

export default {
  ...baseToolUtils,
  onToolClick
}
